import React, {useContext, useState} from "react";
import {userIdContext} from "../App";
import {Routes, Route} from "react-router-dom";
import Home from "./Home";
import Page404 from "./Serving/Page404";

import EditProfile from "./EditProfile";

import Statistics from "./Statistics";

import "../style/mainPart.css";
import MainTasksTable from "./Serving/PriorityTableComponents/MainTasksTable";
import {PublishedTasksTable} from "./Serving/PublishedTasksTable";
import Profile from "./Profile";
import ResponsibilityAreaTable from "./Serving/ResponsibilityAreaTable";
import NewsFeed from "./NewsFeed";

export const targetUserIdContext = React.createContext<any>(false);

export default function MainPart() {
    const userId = useContext(userIdContext);

    const [targetUserId, setTargetUserId] = useState<string>(userId);

    return (
        <div className="mainPart">
            <targetUserIdContext.Provider value={[targetUserId, setTargetUserId]}>
                <Routes>
                    <Route path="/">
                        <Route index element={<Home/>}/>
                        <Route path="statistics" element={<Statistics/>}/>
                        <Route path="tasks" element={<MainTasksTable/>}/>
                        <Route path="publishedtasks" element={<PublishedTasksTable/>}/>
                        <Route path="profile" element={<Profile/>}/>
                        <Route path="editprofile" element={<EditProfile/>}/>
                        <Route path="responsibility" element={<ResponsibilityAreaTable/>}/>
                        <Route path="newsfeed" element={<NewsFeed/>}/>
                        <Route path="*" element={<Page404/>}/>
                    </Route>
                </Routes>
            </targetUserIdContext.Provider>
        </div>
    );
}
